import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface CreateWorkerResponse {
  ok: boolean;
  worker_id: number;
  code: "OK_WORKER_CREATED";
}

export interface CreateWorkerPayload {
  name: string;
  pin: string;
}

export function useCreateWorker() {
  const qc = useQueryClient();
  return useMutation<CreateWorkerResponse, ApiError, CreateWorkerPayload>({
    mutationFn: (p) => apiPost("/api/admin/workers", p),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["workers"] }),
  });
}
